<template>
  <div class="tab">
    <el-footer v-if="$can('create', 'clients')" class="tab__footer page__active_bar">
      <el-button
        id="addClient"
        class="page__active_button"
        type="primary"
        icon="el-icon-plus"
        @click="$router.push({ name: 'client:create' })"
      >
        Добавить
      </el-button>
      <!-- ↓ костыль, чтобы показывать кнопку только для Провзора(621), нужно переделать, когда будет горизонтальное разграничение прав-->
      <el-button
        v-if="idOperator == 621"
        id="addClientsMass"
        class="page__active_button"
        type="primary"
        icon="el-icon-document-add"
        @click="$router.push({ name: 'clients:mass-create' })"
      >
        Импорт из Excel
      </el-button>
    </el-footer>
    <div class="page_container">
      <search :query.sync="query" @search="search" />
      <clients-table @clientDeleted="changePage(page)" />
      <el-pagination
        class="list__pagination"
        layout="prev, pager, next"
        :page-size="count"
        :total="total"
        :current-page="page"
        @current-change="changePage"
      />
    </div>
  </div>
</template>

<script>
import Search from "@/components/Search";
import { mapState, mapActions, mapMutations, mapGetters } from "vuex";
import list from "@/core/mixins/list";
import ClientsTable from "@/components/Clients/features/ClientsTable";

export default {
  name: "ClientsList",
  components: {
    ClientsTable,
    Search,
  },
  mixins: [list],
  data() {
    return { query: "", activeName: "list" };
  },
  computed: {
    idOperator() {
      return localStorage.getItem("operator")
    },
    ...mapState("clients", ["total", "count"]),
    ...mapGetters("clients", ["getQuery"]),
  },
  methods: {
    ...mapActions("clients", {
      getList: "GET_LIST_CLIENTS",
    }),
    ...mapMutations("clients", {
      setQuery: "SET_QUERY",
    }),
  },
};
</script>

<style>
.list,
.list__pagination {
  margin: 20px 0;
}
.list__pagination {
  text-align: center;
}
.el-table th > .cell {
  word-break: break-word;
}
.link {
  line-height: 1;
  cursor: pointer;
  outline: 0;
  margin: 0;
  transition: 0.1s;
  color: #409eff;
}
</style>
